import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SendRemindersComponent } from './reminders.send.component';
import { RemindersService }       from './reminders.service';
import { SharedModule }           from '../shared/shared.module';

@NgModule({
  declarations: [
    SendRemindersComponent
  ],
  entryComponents: [
    SendRemindersComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    RemindersService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class RemindersModule {}
